import { Component, Input, OnInit } from '@angular/core';

import { AlertMessage, MessagePosition } from '../../models/alert-message.model';

@Component({
  selector: 'app-page-not-found-component',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent implements OnInit {

  dismissible = true;
  alerts: any[];

  @Input() position: MessagePosition;

  ngOnInit() {
    this.alerts = [
      new AlertMessage(
        'danger',
        'Une erreur est survenue, veuillez réessayer ultérieurement. Si le problème persiste merci de contacter le support.'
      )
    ];
  }

  onClosed(dismissedAlert: AlertMessage): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

}
